export const categories = [
  { id: 'rexia', name: '热门推荐', slug: 'rexia-recommend', icon: 'ri-fire-line', description: '最受欢迎的韩漫作品，每日更新热门榜单' },
  { id: 'lianai', name: '恋爱漫画', slug: 'lianai-romance', icon: 'ri-heart-line', description: '甜蜜浪漫的韩国恋爱漫画' },
  { id: 'qihuan', name: '奇幻冒险', slug: 'qihuan-fantasy', icon: 'ri-magic-line', description: '奇幻世界与冒险故事的韩国漫画' },
  { id: 'dongzuo', name: '动作热血', slug: 'dongzuo-action', icon: 'ri-sword-line', description: '热血沸腾的韩国动作漫画' },
  { id: 'xuanyi', name: '悬疑惊悚', slug: 'xuanyi-thriller', icon: 'ri-ghost-line', description: '扣人心弦的悬疑惊悚韩国漫画' },
  { id: 'gaoxiao', name: '搞笑日常', slug: 'gaoxiao-comedy', icon: 'ri-emotion-laugh-line', description: '轻松搞笑的韩国日常漫画' },
  { id: 'BL', name: 'BL漫画', slug: 'bl-comics', icon: 'ri-men-line', description: '韩国BL漫画精选合集' },
  { id: 'GL', name: 'GL漫画', slug: 'gl-comics', icon: 'ri-women-line', description: '韩国GL漫画精选合集' },
];

export const mangaList = [
  {
    id: 1,
    title: '女神降临',
    author: '雅英',
    category: 'lianai',
    slug: 'nvshen-jianglin',
    rating: 9.5,
    views: 2850000,
    chapters: 192,
    status: '已完结',
    updateDate: '2026-07-28',
    description: '平凡女孩通过化妆变身校园女神，却陷入与两位男神之间的甜蜜三角恋。当素颜秘密被揭穿，她该如何面对真实的自己与爱情？这部韩国漫画以细腻的画风和真实的情感描绘，展现了青少年成长中的自我认同与爱情故事，深受全球读者喜爱。',
    tags: ['校园', '恋爱', '成长', '化妆', '三角恋'],
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20high%20school%20girl%20transformation%20makeup%20scene%2C%20soft%20romantic%20lighting%2C%20pastel%20pink%20and%20warm%20tones%2C%20modern%20school%20uniform%2C%20manhwa%20cover%20style%2C%20clean%20minimal%20background%20with%20cherry%20blossom%20petals&width=1600&height=900&seq=nvshen-jianglin-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20high%20school%20girl%20transformation%20makeup%20scene%2C%20soft%20romantic%20lighting%2C%20pastel%20pink%20and%20warm%20tones%2C%20modern%20school%20uniform%2C%20manhwa%20cover%20style%2C%20clean%20minimal%20background%20with%20cherry%20blossom%20petals&width=600&height=800&seq=nvshen-jianglin-card&orientation=portrait',
  },
  {
    id: 2,
    title: '我独自升级',
    author: '秋',
    category: 'dongzuo',
    slug: 'wo-duzi-shengji',
    rating: 9.8,
    views: 5200000,
    chapters: 179,
    status: '已完结',
    updateDate: '2026-07-30',
    description: '世界上出现连接异次元与现世的通道"传送门"，觉醒者猎人应运而生。被称为人类最弱兵器的成振宇，在一次双重地下城事故后获得了独特的能力——可以像游戏一样升级变强。从最弱到最强，他独自踏上了拯救世界的征程。',
    tags: ['奇幻', '冒险', '升级', '热血', '猎人'],
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20cover%20style%2C%20powerful%20male%20hunter%20with%20glowing%20aura%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20background%20with%20portal%20effect%2C%20action%20packed&width=1600&height=900&seq=wo-duzi-shengji-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20cover%20style%2C%20powerful%20male%20hunter%20with%20glowing%20aura%2C%20dramatic%20lighting%2C%20dark%20atmospheric%20background%20with%20portal%20effect%2C%20action%20packed&width=600&height=800&seq=wo-duzi-shengji-card&orientation=portrait',
  },
  {
    id: 3,
    title: '看脸时代',
    author: '朴泰俊',
    category: 'dongzuo',
    slug: 'kanlian-shidai',
    rating: 9.4,
    views: 4100000,
    chapters: 210,
    status: '连载中',
    updateDate: '2026-08-01',
    description: '胖男孩朴亨硕长期遭受校园霸凌，转学后神奇地拥有了两副身体——白天是帅气完美的型男，夜晚变回原本的模样。通过两个不同身份的经历，他逐渐看清了这个"看脸"社会的真相，也找到了真正的自我价值。',
    tags: ['校园', '动作', '社会', '成长', '双重身份'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20with%20split%20face%20concept%2C%20one%20side%20handsome%20perfect%20male%20face%20other%20side%20ordinary%2C%20dramatic%20contrast%20lighting%2C%20urban%20school%20background%2C%20clean%20composition&width=1600&height=900&seq=kanlian-shidai-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20with%20split%20face%20concept%2C%20one%20side%20handsome%20perfect%20male%20face%20other%20side%20ordinary%2C%20dramatic%20contrast%20lighting%2C%20urban%20school%20background%2C%20clean%20composition&width=600&height=800&seq=kanlian-shidai-card&orientation=portrait',
  },
  {
    id: 4,
    title: '甜蜜家园',
    author: '金坎比',
    category: 'xuanyi',
    slug: 'tianmi-jiayuan',
    rating: 9.6,
    views: 3600000,
    chapters: 140,
    status: '已完结',
    updateDate: '2026-07-25',
    description: '因校园暴力而隐居的高中生车贤秀，在失去家人后搬进了一栋破旧的公寓。不料世界突然爆发怪物危机，人类会因内心的欲望而变成可怕的怪物。他与公寓里的幸存者们一起，为了生存而战斗。',
    tags: ['惊悚', '怪物', '生存', '悬疑', '人性'],
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20horror%20Korean%20manhwa%20cover%2C%20apartment%20building%20with%20monster%20silhouette%2C%20survival%20theme%2C%20dark%20moody%20atmosphere%2C%20clean%20minimal%20composition%2C%20warm%20dark%20tones&width=1600&height=900&seq=tianmi-jiayuan-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Dark%20horror%20Korean%20manhwa%20cover%2C%20apartment%20building%20with%20monster%20silhouette%2C%20survival%20theme%2C%20dark%20moody%20atmosphere%2C%20clean%20minimal%20composition%2C%20warm%20dark%20tones&width=600&height=800&seq=tianmi-jiayuan-card&orientation=portrait',
  },
  {
    id: 5,
    title: '她的私生活',
    author: '金成妍',
    category: 'lianai',
    slug: 'tade-sishenghuo',
    rating: 9.2,
    views: 1800000,
    chapters: 98,
    status: '已完结',
    updateDate: '2026-07-20',
    description: '美术馆策展人成德美表面上是完美的职场女性，私下却是狂热的偶像追星族。当新任馆长莱恩·戈尔德发现了她的秘密后，两人之间展开了一段令人捧腹又心动的浪漫故事。',
    tags: ['恋爱', '职场', '偶像', '喜剧', '浪漫'],
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20woman%20in%20art%20gallery%20setting%2C%20dual%20life%20concept%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20Korean%20manhwa%20romance%20cover%20style%2C%20clean%20background&width=1600&height=900&seq=tade-sishenghuo-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20woman%20in%20art%20gallery%20setting%2C%20dual%20life%20concept%2C%20romantic%20atmosphere%2C%20soft%20warm%20lighting%2C%20Korean%20manhwa%20romance%20cover%20style%2C%20clean%20background&width=600&height=800&seq=tade-sishenghuo-card&orientation=portrait',
  },
  {
    id: 6,
    title: '全知读者视角',
    author: 'Sing N song',
    category: 'qihuan',
    slug: 'quanzhi-duzhe-shijiao',
    rating: 9.7,
    views: 4800000,
    chapters: 200,
    status: '连载中',
    updateDate: '2026-08-02',
    description: '金独子是一个平凡的公司职员，唯一的爱好是阅读网络小说《在灭亡的世界中生存的三种方法》。当这部小说完结的那一天，小说中的世界竟变成了现实！作为唯一知道这个世界结局的人，他开始了改变命运的冒险。',
    tags: ['奇幻', '末世', '小说', '冒险', '生存'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20man%20reading%20book%20with%20apocalyptic%20world%20behind%2C%20dramatic%20composition%2C%20warm%20and%20dark%20contrast%2C%20clean%20minimal%20background&width=1600&height=900&seq=quanzhi-duzhe-shijiao-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%2C%20man%20reading%20book%20with%20apocalyptic%20world%20behind%2C%20dramatic%20composition%2C%20warm%20and%20dark%20contrast%2C%20clean%20minimal%20background&width=600&height=800&seq=quanzhi-duzhe-shijiao-card&orientation=portrait',
  },
  {
    id: 7,
    title: '梨泰院Class',
    author: '光真',
    category: 'dongzuo',
    slug: 'litaiyuan-class',
    rating: 9.3,
    views: 3200000,
    chapters: 79,
    status: '已完结',
    updateDate: '2026-07-18',
    description: '因一场悲剧失去父亲的朴世路，在梨泰院开了一家小酒馆"甜夜"，他集结了一群不被社会接受的年轻人，共同向着梦想和复仇前进。这是一部关于热血、梦想和不屈不挠精神的创业故事。',
    tags: ['创业', '复仇', '美食', '友情', '励志'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20street%20food%20restaurant%20in%20Itaewon%20night%20scene%2C%20warm%20neon%20lights%2C%20group%20of%20young%20people%2C%20manhwa%20cover%20style%2C%20energetic%20atmosphere%2C%20clean%20composition&width=1600&height=900&seq=litaiyuan-class-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20street%20food%20restaurant%20in%20Itaewon%20night%20scene%2C%20warm%20neon%20lights%2C%20group%20of%20young%20people%2C%20manhwa%20cover%20style%2C%20energetic%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=litaiyuan-class-card&orientation=portrait',
  },
  {
    id: 8,
    title: 'SSS级重生猎人',
    author: '金东贤',
    category: 'qihuan',
    slug: 'sss-chongsheng-lieren',
    rating: 9.1,
    views: 2100000,
    chapters: 132,
    status: '连载中',
    updateDate: '2026-08-03',
    description: '人类最强者SSS级猎人金哲秀在与魔王的最终决战中陨落，却意外重生回到了十年前。带着前世所有的记忆与战斗经验，他决定重新开始，弥补所有遗憾，保护那些曾经逝去的同伴。',
    tags: ['重生', '奇幻', '猎人', '冒险', '战斗'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20hunter%20cover%2C%20powerful%20hunter%20with%20glowing%20weapon%2C%20rebirth%20theme%2C%20dramatic%20golden%20light%2C%20clean%20minimal%20background%2C%20action%20style&width=1600&height=900&seq=sss-chongsheng-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20hunter%20cover%2C%20powerful%20hunter%20with%20glowing%20weapon%2C%20rebirth%20theme%2C%20dramatic%20golden%20light%2C%20clean%20minimal%20background%2C%20action%20style&width=600&height=800&seq=sss-chongsheng-card&orientation=portrait',
  },
  {
    id: 9,
    title: '欢迎来到梦境',
    author: '李恩慧',
    category: 'xuanyi',
    slug: 'huanying-mengjing',
    rating: 9.0,
    views: 1500000,
    chapters: 87,
    status: '连载中',
    updateDate: '2026-07-29',
    description: '心理治疗师林素美发现了一种可以进入患者梦境的新技术。在治疗一位神秘少年时，她发现梦境与现实之间的界限越来越模糊，而少年的梦境中隐藏着可怕的秘密。',
    tags: ['悬疑', '心理', '梦境', '治疗', '惊悚'],
    coverImage: 'https://readdy.ai/api/search-image?query=Dreamy%20surreal%20Korean%20manhwa%20cover%2C%20woman%20entering%20dream%20world%2C%20floating%20islands%2C%20mysterious%20atmosphere%2C%20soft%20ethereal%20lighting%2C%20clean%20minimal%20composition&width=1600&height=900&seq=huanying-mengjing-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Dreamy%20surreal%20Korean%20manhwa%20cover%2C%20woman%20entering%20dream%20world%2C%20floating%20islands%2C%20mysterious%20atmosphere%2C%20soft%20ethereal%20lighting%2C%20clean%20minimal%20composition&width=600&height=800&seq=huanying-mengjing-card&orientation=portrait',
  },
  {
    id: 10,
    title: '社内相亲',
    author: '海华',
    category: 'lianai',
    slug: 'shenei-xiangqin',
    rating: 9.4,
    views: 2600000,
    chapters: 112,
    status: '已完结',
    updateDate: '2026-07-15',
    description: '普通上班族申夏莉代替闺蜜去相亲，本想搞砸相亲的她却发现对方竟是公司的社长！一场充满误会的办公室恋情就此展开，既有令人捧腹的搞笑场面，也有甜蜜心动的浪漫时刻。',
    tags: ['恋爱', '职场', '喜剧', '契约', '办公室'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20office%20cover%2C%20beautiful%20woman%20and%20handsome%20CEO%20at%20restaurant%2C%20romantic%20comedy%20atmosphere%2C%20warm%20lighting%2C%20clean%20minimal%20background&width=1600&height=900&seq=shenei-xiangqin-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20office%20cover%2C%20beautiful%20woman%20and%20handsome%20CEO%20at%20restaurant%2C%20romantic%20comedy%20atmosphere%2C%20warm%20lighting%2C%20clean%20minimal%20background&width=600&height=800&seq=shenei-xiangqin-card&orientation=portrait',
  },
  {
    id: 11,
    title: '鬼灭高中',
    author: '金允基',
    category: 'gaoxiao',
    slug: 'guimie-gaozhong',
    rating: 8.9,
    views: 1200000,
    chapters: 65,
    status: '连载中',
    updateDate: '2026-08-01',
    description: '一群拥有超能力的"鬼"学生进入了普通高中，他们努力隐藏自己的身份，却总是闹出各种啼笑皆非的乌龙。搞笑日常与温馨友情交织的校园喜剧漫画。',
    tags: ['搞笑', '校园', '超能力', '日常', '友情'],
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20school%20comedy%20cover%2C%20supernatural%20students%20in%20classroom%2C%20bright%20colorful%20atmosphere%2C%20humorous%20expressions%2C%20clean%20minimal%20background&width=1600&height=900&seq=guimie-gaozhong-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20school%20comedy%20cover%2C%20supernatural%20students%20in%20classroom%2C%20bright%20colorful%20atmosphere%2C%20humorous%20expressions%2C%20clean%20minimal%20background&width=600&height=800&seq=guimie-gaozhong-card&orientation=portrait',
  },
  {
    id: 12,
    title: '剑尊归来',
    author: '李光洙',
    category: 'qihuan',
    slug: 'jianzun-guilai',
    rating: 9.6,
    views: 3900000,
    chapters: 156,
    status: '连载中',
    updateDate: '2026-08-03',
    description: '天下第一剑尊独孤剑在飞升时被偷袭陨落，灵魂穿越到现代一个普通高中生身上。在这个武术没落的时代，他重新执剑，要让剑道的荣光再次照耀世界。',
    tags: ['奇幻', '武侠', '剑道', '重生', '校园'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%2C%20sword%20master%20with%20flowing%20robes%20in%20modern%20city%2C%20dramatic%20contrast%2C%20clean%20minimal%20background%2C%20powerful%20aura&width=1600&height=900&seq=jianzun-guilai-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20cover%2C%20sword%20master%20with%20flowing%20robes%20in%20modern%20city%2C%20dramatic%20contrast%2C%20clean%20minimal%20background%2C%20powerful%20aura&width=600&height=800&seq=jianzun-guilai-card&orientation=portrait',
  },
  {
    id: 13,
    title: '她的沈清',
    author: '仙林',
    category: 'GL',
    slug: 'tade-shenqing',
    rating: 9.7,
    views: 1800000,
    chapters: 88,
    status: '已完结',
    updateDate: '2026-07-10',
    description: '以古代朝鲜为背景，讲述了两位身份迥异的女性——贵族小姐与平民女子之间跨越阶级的动人故事。唯美细腻的画风，展现了她们在封建社会中相互扶持、勇敢追寻真爱的旅程。',
    tags: ['GL', '古风', '爱情', '阶级', '历史'],
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20GL%20cover%2C%20two%20women%20in%20traditional%20hanbok%2C%20historical%20Korean%20setting%2C%20romantic%20atmosphere%2C%20soft%20natural%20lighting%2C%20elegant%20composition&width=1600&height=900&seq=tade-shenqing-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Korean%20manhwa%20GL%20cover%2C%20two%20women%20in%20traditional%20hanbok%2C%20historical%20Korean%20setting%2C%20romantic%20atmosphere%2C%20soft%20natural%20lighting%2C%20elegant%20composition&width=600&height=800&seq=tade-shenqing-card&orientation=portrait',
  },
  {
    id: 14,
    title: '杀戮跟踪',
    author: 'Kkoobsae',
    category: 'xuanyi',
    slug: 'shalu-genzong',
    rating: 9.1,
    views: 2400000,
    chapters: 71,
    status: '已完结',
    updateDate: '2026-06-28',
    description: '年轻男子尹范无意中发现邻居竟然是连环杀人犯，然而他非但没有报警，反而对这位杀人犯产生了病态的迷恋。一场危险的跟踪游戏就此展开，人性的扭曲令人不寒而栗。',
    tags: ['惊悚', '犯罪', '心理', '黑暗', '悬疑'],
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20thriller%20Korean%20manhwa%20cover%2C%20mysterious%20man%20silhouette%2C%20dark%20alley%20atmosphere%2C%20tense%20mood%2C%20clean%20minimal%20composition&width=1600&height=900&seq=shalu-genzong-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20thriller%20Korean%20manhwa%20cover%2C%20mysterious%20man%20silhouette%2C%20dark%20alley%20atmosphere%2C%20tense%20mood%2C%20clean%20minimal%20composition&width=600&height=800&seq=shalu-genzong-card&orientation=portrait',
  },
  {
    id: 15,
    title: '奶酪陷阱',
    author: '顺天',
    category: 'lianai',
    slug: 'nailao-xianjing',
    rating: 9.3,
    views: 2900000,
    chapters: 108,
    status: '已完结',
    updateDate: '2026-07-05',
    description: '努力的女大学生洪雪在休学后重返校园，遇到了完美的学长刘正。然而这位看似温柔体贴的学长背后却隐藏着不为人知的另一面。一部深刻描绘大学人际关系与爱情的心理恋爱漫画。',
    tags: ['恋爱', '校园', '心理', '悬疑', '大学'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20university%20romance%20cover%2C%20young%20couple%20on%20campus%2C%20subtle%20psychological%20tension%2C%20warm%20autumn%20tones%2C%20clean%20minimal%20background&width=1600&height=900&seq=nailao-xianjing-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20university%20romance%20cover%2C%20young%20couple%20on%20campus%2C%20subtle%20psychological%20tension%2C%20warm%20autumn%20tones%2C%20clean%20minimal%20background&width=600&height=800&seq=nailao-xianjing-card&orientation=portrait',
  },
  {
    id: 16,
    title: '外星人',
    author: '金奎森',
    category: 'gaoxiao',
    slug: 'waixingren',
    rating: 8.8,
    views: 980000,
    chapters: 54,
    status: '连载中',
    updateDate: '2026-07-31',
    description: '外星人实习生来到地球公司上班，对地球人的一切感到新奇又困惑。每天在公司闹出各种笑话，却也在不知不觉中学会了地球人的情感与温暖。',
    tags: ['搞笑', '科幻', '职场', '日常', '外星人'],
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20cover%2C%20alien%20character%20in%20office%20suit%2C%20comedy%20workplace%20setting%2C%20bright%20colorful%20atmosphere%2C%20clean%20minimal%20background&width=1600&height=900&seq=waixingren-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20cover%2C%20alien%20character%20in%20office%20suit%2C%20comedy%20workplace%20setting%2C%20bright%20colorful%20atmosphere%2C%20clean%20minimal%20background&width=600&height=800&seq=waixingren-card&orientation=portrait',
  },
  {
    id: 17,
    title: '语义错误',
    author: 'Jeosuri',
    category: 'BL',
    slug: 'yuyi-cuowu',
    rating: 9.5,
    views: 2200000,
    chapters: 84,
    status: '已完结',
    updateDate: '2026-07-22',
    description: '严格遵守规则的计算机系学霸张宰英遇到了自由奔放的设计系学长秋尚宇，两人因小组项目被迫合作。性格截然相反的两人从互相看不顺眼到逐渐被对方吸引，展开了一段充满火花的校园恋情。',
    tags: ['BL', '校园', '恋爱', '喜剧', '大学'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20handsome%20university%20students%2C%20romantic%20campus%20atmosphere%2C%20warm%20lighting%2C%20clean%20minimal%20background&width=1600&height=900&seq=yuyi-cuowu-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20manhwa%20cover%2C%20two%20handsome%20university%20students%2C%20romantic%20campus%20atmosphere%2C%20warm%20lighting%2C%20clean%20minimal%20background&width=600&height=800&seq=yuyi-cuowu-card&orientation=portrait',
  },
  {
    id: 18,
    title: '恶女是提线木偶',
    author: '芒果椰子',
    category: 'lianai',
    slug: 'env-muxian-muou',
    rating: 9.2,
    views: 1950000,
    chapters: 120,
    status: '连载中',
    updateDate: '2026-08-02',
    description: '穿越成为小说中的恶毒女配凯琳娜，为了不被当作傀儡嫁给残暴的皇太子，她决定先发制人去诱惑他。然而事情的发展完全超出了她的预料，皇太子似乎也隐藏着不为人知的秘密。',
    tags: ['恋爱', '穿越', '宫廷', '恶女', '奇幻'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20romance%20cover%2C%20beautiful%20villainess%20in%20elegant%20dress%2C%20palace%20background%2C%20romantic%20and%20dramatic%20atmosphere%2C%20clean%20minimal%20composition&width=1600&height=900&seq=env-muxian-muou-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20royal%20romance%20cover%2C%20beautiful%20villainess%20in%20elegant%20dress%2C%20palace%20background%2C%20romantic%20and%20dramatic%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=env-muxian-muou-card&orientation=portrait',
  },
  {
    id: 19,
    title: '狂王',
    author: '金仁坤',
    category: 'dongzuo',
    slug: 'kuangwang',
    rating: 9.4,
    views: 1600000,
    chapters: 95,
    status: '已完结',
    updateDate: '2026-06-15',
    description: '被囚禁在黑暗地牢十五年的王子，在亡国之际逃出生天。他凭借惊人的战斗天赋和复仇的决心，一步步夺回属于自己的王位。一部充满暴力美学与权谋斗争的史诗级漫画。',
    tags: ['动作', '复仇', '宫廷', '权谋', '战斗'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20fierce%20warrior%20prince%20with%20sword%2C%20dark%20castle%20background%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20clean%20minimal%20composition&width=1600&height=900&seq=kuangwang-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%2C%20fierce%20warrior%20prince%20with%20sword%2C%20dark%20castle%20background%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20clean%20minimal%20composition&width=600&height=800&seq=kuangwang-card&orientation=portrait',
  },
  {
    id: 20,
    title: '末日巡逻队',
    author: '崔胜元',
    category: 'qihuan',
    slug: 'mori-xunluodui',
    rating: 8.7,
    views: 850000,
    chapters: 62,
    status: '连载中',
    updateDate: '2026-07-27',
    description: '末日降临，丧尸横行。一群各怀绝技的幸存者组成巡逻队，在废土世界中寻找希望与生存资源。他们不仅要对抗丧尸，还要面对人性中最黑暗的一面。',
    tags: ['末世', '丧尸', '生存', '冒险', '科幻'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalypse%20cover%2C%20survivors%20fighting%20zombies%2C%20destroyed%20city%20background%2C%20dramatic%20action%20scene%2C%20clean%20minimal%20composition&width=1600&height=900&seq=mori-xunluodui-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20apocalypse%20cover%2C%20survivors%20fighting%20zombies%2C%20destroyed%20city%20background%2C%20dramatic%20action%20scene%2C%20clean%20minimal%20composition&width=600&height=800&seq=mori-xunluodui-card&orientation=portrait',
  },
  {
    id: 21,
    title: '魔道祖师',
    author: '墨香铜臭',
    category: 'BL',
    slug: 'modao-zushi',
    rating: 9.8,
    views: 3500000,
    chapters: 136,
    status: '已完结',
    updateDate: '2026-07-12',
    description: '一代魔道祖师魏无羡重生后与旧友蓝忘机重逢，两人携手揭开前世今生的种种谜团。仙侠世界中的恩怨情仇，正邪之间的模糊界限，成就了一段荡气回肠的传奇故事。',
    tags: ['BL', '仙侠', '重生', '悬疑', '古风'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20xianxia%20cover%2C%20two%20cultivators%20in%20flowing%20robes%2C%20ancient%20Chinese%20fantasy%20setting%2C%20mystical%20atmosphere%2C%20clean%20minimal%20background&width=1600&height=900&seq=modao-zushi-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20xianxia%20cover%2C%20two%20cultivators%20in%20flowing%20robes%2C%20ancient%20Chinese%20fantasy%20setting%2C%20mystical%20atmosphere%2C%20clean%20minimal%20background&width=600&height=800&seq=modao-zushi-card&orientation=portrait',
  },
  {
    id: 22,
    title: '神级外卖员',
    author: '赵石',
    category: 'gaoxiao',
    slug: 'shenji-waimaiyuan',
    rating: 9.0,
    views: 1350000,
    chapters: 78,
    status: '连载中',
    updateDate: '2026-08-01',
    description: '一个拥有瞬间移动超能力的青年选择做外卖员，各种奇葩顾客和离奇订单让他每天的生活都充满意外。搞笑中带着温情，展现了都市小人物的酸甜苦辣。',
    tags: ['搞笑', '超能力', '都市', '日常', '外卖'],
    coverImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20cover%2C%20delivery%20man%20with%20superpowers%20on%20scooter%2C%20colorful%20city%20background%2C%20comedic%20atmosphere%2C%20bright%20energetic%20composition&width=1600&height=900&seq=shenji-waimaiyuan-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Funny%20Korean%20manhwa%20cover%2C%20delivery%20man%20with%20superpowers%20on%20scooter%2C%20colorful%20city%20background%2C%20comedic%20atmosphere%2C%20bright%20energetic%20composition&width=600&height=800&seq=shenji-waimaiyuan-card&orientation=portrait',
  },
  {
    id: 23,
    title: '陷入深渊',
    author: '沈娜英',
    category: 'GL',
    slug: 'xianru-shenyuan',
    rating: 9.3,
    views: 1250000,
    chapters: 72,
    status: '已完结',
    updateDate: '2026-06-20',
    description: '音乐制作人金荷娜遇到了才华横溢的女歌手朴秀雅，两人在音乐创作中擦出火花。然而娱乐圈的残酷与社会的偏见，让这段感情充满了挑战与考验。',
    tags: ['GL', '音乐', '娱乐圈', '恋爱', '都市'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20music%20cover%2C%20two%20women%20musicians%20in%20recording%20studio%2C%20romantic%20atmosphere%2C%20warm%20dim%20lighting%2C%20elegant%20composition&width=1600&height=900&seq=xianru-shenyuan-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20GL%20music%20cover%2C%20two%20women%20musicians%20in%20recording%20studio%2C%20romantic%20atmosphere%2C%20warm%20dim%20lighting%2C%20elegant%20composition&width=600&height=800&seq=xianru-shenyuan-card&orientation=portrait',
  },
  {
    id: 24,
    title: '杀人者的购物中心',
    author: '姜智英',
    category: 'xuanyi',
    slug: 'sharenzhe-gouwu',
    rating: 9.5,
    views: 2100000,
    chapters: 96,
    status: '已完结',
    updateDate: '2026-07-08',
    description: '郑进湾是一个神秘的武器商人，经营着一个表面普通的购物中心，实际上是面向杀手的军火交易平台。当他的侄子继承了这一切后，一个庞大的杀手网络和背后的惊天阴谋逐渐浮出水面。',
    tags: ['悬疑', '动作', '犯罪', '家族', '杀手'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20crime%20thriller%20cover%2C%20mysterious%20shopping%20mall%20with%20weapons%2C%20dark%20atmospheric%20lighting%2C%20tense%20mood%2C%20clean%20minimal%20composition&width=1600&height=900&seq=sharenzhe-gouwu-hero&orientation=landscape',
    cardImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20crime%20thriller%20cover%2C%20mysterious%20shopping%20mall%20with%20weapons%2C%20dark%20atmospheric%20lighting%2C%20tense%20mood%2C%20clean%20minimal%20composition&width=600&height=800&seq=sharenzhe-gouwu-card&orientation=portrait',
  },
];